module.exports = __webpack_public_path__ + "img/mr-status.859060c6.png";